import { Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation } from '@angular/core';

/**
 *
 * A basic New Visions button component
 *
 *  NvButtonComponent
 */

@Component({
  selector: 'nv-button',
  template: require('./nv-button.component.html'),
  styles: [require('./nv-button.scss')],
  encapsulation: ViewEncapsulation.Emulated,
})
export class NvButtonComponent {
  /**
   *
   * Defines the color of the button
   * - primary - color: --color-white | background-color: --color-blue
   * - secondary - color: --color-blue | background-color: --color-white
   * - tertiary - color: --color-blue | background-color: --color-blue-10
   */
  @Input() type: 'primary' | 'secondary' | 'tertiary' = 'primary';

  /**
   *
   * Determines if the button is clickable
   */
  @Input() disabled: boolean = false;

  /**
   *
   * Size of the button
   */
  @Input() size: 'normal' | 'small' = 'normal';

  /**
   *
   * The name of the icon to display
   */
  @Input() icon: string;

  /**
   *
   *
   */
  @Output() clickButton: EventEmitter<any> = new EventEmitter<any>();

  @HostBinding('class.small') get isSmall() {
    return this.size === 'small';
  }
  @HostBinding('class.primary') get isPrimary() {
    return this.type === 'primary';
  }
  @HostBinding('class.secondary') get isSecondary() {
    return this.type === 'secondary';
  }
  @HostBinding('class.tertiary') get isTertiary() {
    return this.type === 'tertiary';
  }

  @HostBinding('class.is-disabled') get isDisabled() {
    return this.disabled;
  }
  @HostBinding('class.hasIcon') get hasIcon() {
    return !!this.icon;
  }

  public get shouldShowIcon(): boolean {
    return !!this.icon;
  }

  public get isIconInverted(): boolean {
    return !!(this.type === 'primary');
  }

  handleClick(event?: Event) {
    if (this.disabled) {
      event.stopPropagation();
    } else {
      this.clickButton.emit(true); // Emit the `press` event
    }
  }
}
